import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      minHeight: [0, '19px'], // prevent v-jump while loading
      minWidth: '40px',
      mr: [4, 4],
      position: 'relative',
    };

    this.loader = {
      height: '12px',
      color: 'mediumDarkGray',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    };

    this.badges = {
      variant: 'flex.row.start.center',
      width: '100%',
      ml: 5,
    };

    // Amount styles
    this.badge = {
      oneTime: {
        variant: 'badges.sellingPlan',
      },
      subscription: {
        variant: 'badges.sellingPlan',
        bg: 'dark',
      },
      sale: {
        variant: 'badges.sellingPlan',
        bg: 'red',
        ml: 3,
      },
    };

    this.price = {
      lineThrough: {
        variant: 'text.base',
        textDecoration: 'line-through',
        ml: 4,
        color: 'mediumDarkGray',
      },

      new: {
        variant: 'text.base',
        color: 'red',
      },

      regular: {
        variant: 'text.base',
      },
    };
  })()
);
